import { render, staticRenderFns } from "./DataPermanence.vue?vue&type=template&id=6412cbd1"
import script from "./DataPermanence.vue?vue&type=script&lang=js"
export * from "./DataPermanence.vue?vue&type=script&lang=js"
import style0 from "./DataPermanence.vue?vue&type=style&index=0&id=6412cbd1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports